export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://coffee-finder-api.onrender.com'
  : 'http://localhost:4000';